// src/components/Pagination.js
import React from "react";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";

const Pagination = ({ currentPage, totalPages, onNextPage, onPrevPage, onPageChange }) => {
  const renderPageNumbers = () => {
    const pages = [];
    for (let i = 1; i <= totalPages; i++) {
      if (
        i === 1 ||
        i === totalPages ||
        (i >= currentPage - 1 && i <= currentPage + 1)
      ) {
        pages.push(
          <button
            key={i}
            onClick={() => onPageChange(i)} // ✅ call parent function
            className={`w-9 h-9 flex items-center justify-center rounded-full text-sm font-medium transition-all ${
              currentPage === i
                ? "bg-blue-600 text-white shadow-md"
                : "bg-white text-slate-700 border border-slate-300 hover:bg-slate-100"
            }`}
          >
            {i}
          </button>
        );
      } else if (
        (i === currentPage - 2 && currentPage > 3) ||
        (i === currentPage + 2 && currentPage < totalPages - 2)
      ) {
        pages.push(
          <span key={i} className="px-2 text-slate-400">
            ...
          </span>
        );
      }
    }
    return pages;
  };

  return (
    <div className="flex items-center justify-center gap-3 p-4 bg-white border-t border-slate-200">
      {/* Previous Button */}
      <button
        onClick={onPrevPage}
        disabled={currentPage <= 1}
        className="w-9 h-9 flex items-center justify-center rounded-full border border-slate-300 bg-white text-slate-600 hover:bg-slate-100 disabled:opacity-50 disabled:cursor-not-allowed"
      >
        <FaArrowLeft size={12} />
      </button>

      {/* Page Numbers */}
      <div className="flex items-center gap-2">{renderPageNumbers()}</div>

      {/* Next Button */}
      <button
        onClick={onNextPage}
        disabled={currentPage >= totalPages}
        className="w-9 h-9 flex items-center justify-center rounded-full border border-slate-300 bg-white text-slate-600 hover:bg-slate-100 disabled:opacity-50 disabled:cursor-not-allowed"
      >
        <FaArrowRight size={12} />
      </button>
    </div>
  );
};

export default Pagination;
